import type { IRepairItem } from '@/types/rc/miners'
import axios from 'axios'

/**
 * Get all repair items
 */
export const getRepairItems = async () => {
  const res = await axios.get<IRepairItem[]>(`${import.meta.env.VITE_APP_RC_API}/repair-items`)
  return res.data
}

export interface CreateRepairItemForm {
  repair_item_id: number
}

/**
 * Create a repair item on a failure
 * @param failureId the failure to add the repair item to
 * @param data the repair item data (its `id`)
 */
export const createRepairItem = async (failureId: number, data: CreateRepairItemForm) => {
  const res = await axios.post(`${import.meta.env.VITE_APP_RC_API}/failures/${failureId}/repair-items`, data)
  return res.data
}

/**
 * Delete a repair action on a failure
 * @param failureId the failure to add the repair item to
 * @param data the repair item data (its `id`)
 */
export const deleteRepairItem = async (failureId: number, data: CreateRepairItemForm) => {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_API}/failures/${failureId}/repair-items`, { data })
  return res.data
}
